import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function dateRangeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startDateControl = control.get('startDate');
      const endDateControl = control.get('endDate');

      if (!startDateControl || !endDateControl) return null;

      const startDate = startDateControl.value;
      const endDate = endDateControl.value;

      if (startDate && endDate) {
        if (new Date(startDate) > new Date(endDate)) {
          startDateControl.setErrors({ startDateAfterEndDate: true });
          
        } else {
          if (startDateControl.hasError('startDateAfterEndDate')) {
            startDateControl.setErrors(null);
          }
        }
      }
      return null; 
    };
}
